import React, {useEffect, useRef} from 'react';

const Input = props => {
    const {
            type = 'text',
            label,
            placeholder,
            value = '',
            defaultValue,
            readOnly = false,
            disabled,
            className = '',
            style,
            rows,
            name,
            id,
            onChange,
            onKeyDown,
            onKeyUp,
            onKeyPress,
            autoFocus = false,
            autoComplete,
            minLength,
            maxLength,
        } = props,
        classes = ['form-control', className],
        ref = useRef();

    // focus field
    useEffect(() => {
        if (autoFocus && ref.current) {
            ref.current.focus();
        }
    }, []);

    // Trigger onChange event with default value on mount
    useEffect(() => {
        if (!value && defaultValue && onChange) {
            onChange(defaultValue);
        }
    }, []);

    const handleChange = event => {
        onChange(event.target.value);
    };

    return (
        <label className={classes.join(' ')} readOnly={!!readOnly}>
            {label}
            {type == 'textarea' ? (
                <textarea
                    ref={ref}
                    id={id}
                    name={name}
                    rows={rows}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={onKeyDown}
                    onKeyUp={onKeyUp}
                    onKeyPress={onKeyPress}
                    placeholder={placeholder}
                    style={style}
                    disabled={disabled}
                    autoComplete={autoComplete}
                    readOnly={!!readOnly}
                />
            ) : (
                <input
                    ref={ref}
                    id={id}
                    name={name}
                    type={type}
                    value={value}
                    onChange={handleChange}
                    onKeyDown={onKeyDown}
                    onKeyUp={onKeyUp}
                    onKeyPress={onKeyPress}
                    placeholder={placeholder}
                    style={style}
                    disabled={disabled}
                    autoComplete={autoComplete}
                    readOnly={!!readOnly}
                    minLength={minLength}
                    maxLength={maxLength}
                />
            )}
        </label>
    );
};

export default Input;
